import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../pages/Home';
import HowDoesItWork from '../pages/HowDoesItWork';
import WhatWillILearn from '../pages/WhatWillILearn';
import styled from 'styled-components';
import ThankYou from '../pages/ThankYou';
import ParticipantDetails from '../pages/ParticipantDetails';
import YourAvatar from '../pages/YourAvatar';
import LearningOutcomes from '../pages/LearningOutcomes';
import { avatarData } from '../data/avatarData';
import Question from './Question';
import MyAvatars from '../pages/MyAvatars';
import Gallery from './Gallery';

const PageHolder = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const Page = styled.div`
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  position: relative;
  margin: 2rem 2rem;
`;
const Holder = styled.div`
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  > :first-child { margin-top: 0; > :first-child { margin-top: 0; } }
  > :last-child { margin-bottom: 0; > :last-child { margin-bottom: 0; } }
`;

const routes = [
  { path: '/', Component: Home },
  { path: '/how-does-it-work', Component: HowDoesItWork },
  { path: '/what-will-i-learn', Component: WhatWillILearn },
  { path: '/your-avatar', Component: YourAvatar },
  { path: '/thank-you', Component: ThankYou },
  { path: '/participant-details', Component: ParticipantDetails },
  { path: '/learning-outcomes', Component: LearningOutcomes },
  { path: '/my-avatars', Component: MyAvatars },
];

function Content() {

  const [ avatarRoutes, setAvatarRoutes ] = useState( [] );

  useEffect( () => {
    let tempRoutes = [];

    avatarData.forEach( avatar => {
      avatar.options.forEach( ( option, i ) => {
        let tempOption = option;
        tempOption[ 'avatarPrefix' ] = avatar.prefix;
        tempOption[ 'avatarImage' ] = avatar.image;
        tempOption[ 'path' ] = `/${avatar.name}-${option.id}`;
        tempOption[ 'redirect' ] = avatar.options[ i + 1 ] ? `/${avatar.name}-${avatar.options[ i + 1 ].id}` : '/your-avatar';
        tempRoutes.push( tempOption );
      } )
    } );

    setAvatarRoutes( tempRoutes );

  }, [] );

  return (
    <PageHolder>
      <Page>
        <Switch>
          {routes.map( ( { path, Component } ) => (
            <Route key={path} exact path={path}>
              <Holder>
                <Component/>
              </Holder>
            </Route>
          ) )}
          {avatarRoutes.map( route => (
            <Route key={route.path} path={route.path}>
              <Holder>
                <Question
                  data={route}
                  question={route.question}
                  redirect={route.redirect}
                  questionKey={route.id}
                  options={route.values}/>
              </Holder>
            </Route>
          ) )}
          {avatarData.map(avatar => (
            <Route key={avatar.name} path={`/${avatar.name}-gallery`}>
              <Holder>
                <Gallery id={avatar.id} image={avatar.image} prefix={avatar.prefix}/>
              </Holder>
            </Route>
          ))}
        </Switch>
      </Page>
    </PageHolder>
  )
}

export default Content;
